// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1EVzS","active":"Modal_active__18klH","modalContent":"Modal_modalContent__3AXGQ"};